export const TRANSLATION_KEYS = {
	ERRORS: 'errors',
	DIALOG: 'dialog',
	DB_LABELS: 'dbLabels',
	CLIENT_LABELS: 'clientLabels',
};
export const SERVICES_SHORT_TRANSLATION_KEY = 'short';
// for the moment we have special needs only on 'others'
export enum SERVICES_GROUPS {
	OTHERS = 'others',
}

export enum RESET_SELECTED_ROUTES {
	VIEW_CLAIMS = '/view-claims',
}

export enum BILLING_STATUS {
	not_billed = 'NotBilled',
	sent_for_billing = 'SentForBilling',
	billed = 'Billed',
	settled = 'Settled',
	billed_mismatched = 'BilledMismatched',
	rebilled = 'Rebilled',
}

export const DEBOUNCE_DELAY = 500;

export const CLAIM_NOTE_MAX_LENGTH = 250;
export const REJECT_REASON_MAX_LENGTH = 500;
export const COMPLAINT_NOTE_MAX_LENGTH = 250;
export const CLAIM_COMMENT_MAX_LENGTH = 250;
